export const VideoIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.00024 6H11.0002M1.00024 3.5H3.50024M8.50024 3.5H11.0002M1.00024 8.5H3.50024M8.50024 8.5H11.0002M3.50024 11V1M8.50024 11V1M3.40024 11H8.60024C9.44032 11 9.86036 11 10.1812 10.8365C10.4635 10.6927 10.6929 10.4632 10.8368 10.181C11.0002 9.86012 11.0002 9.44008 11.0002 8.6V3.4C11.0002 2.55992 11.0002 2.13988 10.8368 1.81901C10.6929 1.53677 10.4635 1.3073 10.1812 1.16349C9.86036 1 9.44032 1 8.60024 1H3.40024C2.56017 1 2.14013 1 1.81926 1.16349C1.53702 1.3073 1.30754 1.53677 1.16373 1.81901C1.00024 2.13988 1.00024 2.55992 1.00024 3.4V8.6C1.00024 9.44008 1.00024 9.86012 1.16373 10.181C1.30754 10.4632 1.53702 10.6927 1.81926 10.8365C2.14013 11 2.56017 11 3.40024 11Z"
        stroke="white"
        stroke-width="1.22727"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
